import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React from 'react';
import CaptureClicks from '../CaptureClicks';
import { MuiTypography } from '../material-ui';
import { TableProps } from './Table.interface';
import useStyles from './Table.styles';

const Table = ({
  heading,
  description,
  table,
  inline,
  theme = Theme.light,
}: PropsWithTheme<TableProps>) => {
  const classes = useStyles({});
  const rootClassName = clsx(classes.root, `${theme}-theme`, inline && classes.inline);

  return (
    <div className={rootClassName}>
      <div>
        {heading && (
          <MuiTypography variant="h4" className={classes.text}>
            {heading}
          </MuiTypography>
        )}
        {description && (
          <MuiTypography variant="body1" className={classes.text}>
            {description}
          </MuiTypography>
        )}
      </div>
      {/* eslint-disable-next-line react/no-danger */}
      {table && <div className={classes.container} dangerouslySetInnerHTML={{ __html: table }} />}
    </div>
  );
};

export const CaptureClicksTable = CaptureClicks(Table);

export default Table;
